export default __webpack_public_path__ + "static/media/FictionFlow.26f42f8c.png";